import React, { memo } from 'react';
import { IoMdArrowBack } from 'react-icons/io';
import history from '~/services/history';

import { Container } from './style';

const ButtonBack = () => {
  return (
    <Container>
      <button type="button" onClick={() => history.goBack()}>
        <IoMdArrowBack size={15} /> Voltar
      </button>
    </Container>
  );
};

export default memo(ButtonBack);
